import React from "react"
import { HStack, Button, Text } from "@chakra-ui/react"
import {
  ArrowBackIcon,
  ArrowForwardIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@chakra-ui/icons"

export const Paginator = ({ offset, total, limit, setOffset }) => {
  const pageCount = Math.ceil(total / limit)

  const startItem = Math.min(offset + 1, total)
  const endItem = Math.min(offset + limit, total)

  if (total <= limit) {
    return <></>
  }

  const onPaginationChange = (newOffset) => {
    setOffset(newOffset)
  }

  return (
    <HStack
      alignItems="center"
      justifyContent="center"
      spacing="1em"
      width="100%"
      bg="white"
      borderRadius="0.5em"
      boxShadow="sm"
      height="2.5em"
      mb="1em"
    >
      <Button
        size="xs"
        variant="primary"
        onClick={() => onPaginationChange(0)}
        isDisabled={offset === 0}
      >
        <ArrowBackIcon />
      </Button>
      <Button
        size="xs"
        variant="primary"
        onClick={() => onPaginationChange(offset - limit)}
        isDisabled={offset === 0}
      >
        <ChevronLeftIcon />
      </Button>
      <Text minW="fit-content">{`${startItem}-${endItem} / ${total}`}</Text>
      <Button
        size="xs"
        variant="primary"
        onClick={() => onPaginationChange(offset + limit)}
        isDisabled={offset + limit >= total}
      >
        <ChevronRightIcon />
      </Button>
      <Button
        size="xs"
        variant="primary"
        onClick={() => onPaginationChange((pageCount - 1) * limit)}
        isDisabled={offset + limit >= total}
      >
        <ArrowForwardIcon />
      </Button>
    </HStack>
  )
}
